import { render, staticRenderFns } from "./shippers.vue?vue&type=template&id=102af6dc&"
import script from "./shippers.vue?vue&type=script&lang=js&"
export * from "./shippers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports